<div
  [ngClass]="activeTheme"
  [ngStyle]="styles">
  <section class="hero"
           [ngClass]="{'loading': !!showBgImage, 'white-bg': !!openMenu}"
           [ngStyle]="{backgroundImage: 'url(&quot;'+ (generationFinished ? 'data:image/jpg;base64,' : '') + generatedTexts?.image + '&quot;)'}">
    <header class="header">
      <nav class="navbar">
        <div>
          <div class="logo"
               [ngClass]="{'ds-lazy-load': !showHeaderSection, 'fade-in': showHeaderSection, 'black' : !!openMenu}">
            <span>{{logoTitle || 'Logo'}}</span>
          </div>
          <ul class="nav-links" *ngIf="!isMobile">
            <li *ngFor="let item of fadeInMenuElements; let i = index"
                [ngClass]="{'ds-lazy-load': !fadeInMenuElements[i]}">
              <a [ngClass]="{'fade-in': !!fadeInMenuElements[i]}">{{ menuPages[i]?.page?.title }}</a>
            </li>
          </ul>
          <div class="mobile-menu" id="menu" *ngIf="!!isMobile">
            <ul>
              <li>Page 1</li>
              <li>Page 2</li>
              <li>Page 3</li>
              <li>Page 4</li>
              <li>Page 5</li>
              <li>Page 6</li>
            </ul>
          </div>
        </div>
        <div class="hero-ecommerce">
          <i *ngIf="isEcommerce" class="db-icon db-icon-ds-user" [ngClass]="{'ds-lazy-load': !showHeaderBg, 'fade-in': showHeaderBg, 'black' : !!openMenu}"></i>
          <i *ngIf="isEcommerce" class="db-icon db-icon-ds-ecommerce-bag" [ngClass]="{'ds-lazy-load': !showHeaderBg, 'fade-in': showHeaderBg, 'black' : !!openMenu}"></i>
          <i *ngIf="!!isMobile && !openMenu" (click)="!!showHeaderBg && toggleMenu()" class="db-icon db-icon-ds-burger"  [ngClass]="{'ds-lazy-load': !showHeaderBg, 'fade-in': showHeaderBg, 'black' : !!openMenu}"></i>
          <i *ngIf="!!isMobile && !!openMenu" (click)="!!showHeaderBg && toggleMenu()" class="db-icon db-icon-ds-close-sharp"  [ngClass]="{'ds-lazy-load': !showHeaderBg, 'fade-in': showHeaderBg, 'black' : !!openMenu}"></i>
        </div>
        <button *ngIf="!isMobile && !isEcommerce" class="cta" [ngClass]="{'ds-lazy-load': !showHeaderBg, 'fade-in': showHeaderBg}">
          <span>{{generatedTexts?.cta}}</span>
        </button>
      </nav>
    </header>
    <div class="hero-content">
      <div>
        <div class="title-section"
             [ngClass]="fadeInContentElements[0] ? 'fade-in' : 'ds-lazy-load'">
          <h1 [innerHTML]="generatedTexts?.title"></h1>
        </div>
        <div class="desc-section mt20 mb40" [ngClass]="fadeInContentElements[1] ? 'fade-in' : 'ds-lazy-load'">
          <p [innerHTML]="generatedTexts?.description"></p>
        </div>
      </div>
      <button class="cta"
              [ngClass]="fadeInContentElements[2] ? 'fade-in' : 'ds-lazy-load'">
        <span>{{generatedTexts?.cta}}</span>
      </button>
    </div>
  </section>
</div>
